var map = {
	"./admin_settings.png": 1425,
	"./catalog.png": 1426,
	"./catalog_order.png": 1427,
	"./cms.png": 1428,
	"./component-fields/Asset.png": 1429,
	"./component-fields/Blocks.png": 1430,
	"./component-fields/Boolean.png": 1431,
	"./component-fields/Date-time.png": 1432,
	"./component-fields/LInk.png": 1433,
	"./component-fields/Markdown.png": 1434,
	"./component-fields/Multi asset.png": 1435,
	"./component-fields/Multi options.png": 1436,
	"./component-fields/Number.png": 1437,
	"./component-fields/Richtext.png": 1438,
	"./component-fields/Single options.png": 1439,
	"./component-fields/Table.png": 1440,
	"./component-fields/Text area.png": 1441,
	"./component-fields/Text.png": 1442,
	"./components.png": 1443,
	"./configuration.png": 1444,
	"./contents.png": 1445,
	"./custom_order.png": 1446,
	"./customer_credits.png": 1447,
	"./dashboard.png": 1448,
	"./dashboard_available_credit.png": 1449,
	"./dashboard_due_soon.png": 1450,
	"./dashboard_invoices.png": 1451,
	"./dashboard_market.png": 1452,
	"./dashboard_messages.png": 1453,
	"./dashboard_new_arrivals.png": 1321,
	"./dashboard_new_catalog_order.png": 1316,
	"./dashboard_new_custom_order.png": 1318,
	"./dashboard_new_estimate.png": 1317,
	"./dashboard_new_payment.png": 1320,
	"./dashboard_new_repair.png": 1319,
	"./dashboard_orders.png": 1454,
	"./dashboard_past_due.png": 1455,
	"./dashboard_quotes.png": 1456,
	"./dashboard_sales_orders.png": 1457,
	"./dashboard_total_payable.png": 1458,
	"./estimate.png": 1459,
	"./financials.png": 1460,
	"./home.png": 1461,
	"./invoices.png": 1462,
	"./media_library.png": 1463,
	"./move.png": 1464,
	"./order_creation.png": 1465,
	"./orders.png": 1466,
	"./payment-methods/amex.png": 1195,
	"./payment-methods/discover.png": 1199,
	"./payment-methods/mastercard.png": 1200,
	"./payment-methods/visa.png": 1201,
	"./payment.png": 1467,
	"./product_catalog.png": 1468,
	"./products.png": 1469,
	"./quote-icon.png": 1470,
	"./quotes.png": 1471,
	"./quotes_approve.png": 1472,
	"./repair_order.png": 1473,
	"./sales_orders.png": 1474,
	"./status_tracking.png": 1475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1217;